import React from 'react'
import searchIcon from '../images/searchIcon.svg'

class SearchComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      keySearch: ''
    }
  }
  search () {
    this.props.getKeySearch(this.state.keySearch)
  }
  handleChange (e) {
    this.setState({
      keySearch: e.target.value
    })
    this.props.getKeySearch(e.target.value)
  }

  render () {
    return (
      <div style={styles.searchContent}>
        <input
          style={styles.input}
          type='text'
          placeholder='Rechercher'
          onChange={(e) => this.handleChange(e)}
        />
        <div onClick={() => this.search()}>
          <img
            style={styles.icon}
            src={searchIcon}
            alt='true'
          />
        </div>
      </div>
    )
  }
}

const styles = {
  searchContent: {
    marginTop: '6px',
    float: 'right',
    width: '314px'
  },
  input: {
    height: '26px',
    width: '262px',
    float: 'left',
    marginLeft: '12px',
    marginTop: '4px',
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
    borderWidth: '0px',
    color: '#1B1F22',
    fontSize: '13px',
    fontWeight: 500,
    paddingLeft: '10px'
  },
  icon: {
    float: 'left',
    height: '28px',
    marginTop: '4px'
  }
}

export default SearchComponent
